<micro-select-combo #sel
              placeholder="SMS Reply Config"
              routerBase="sms/smsMoToEmails"
              [mode]="mode"
              [(id)]="smsMoToEmailId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
